import {API_NAME} from './apiConstants';
import {allowedKeysForTolkien, CLIENT_ID_HEADER, CORRELATION_ID_HEADER} from './networkConstants';
import {generateRandomGuid} from '../string/stringUtils';

function generateCustomHeadersForTracking() {
  return {
    [CLIENT_ID_HEADER]: API_NAME,
    [CORRELATION_ID_HEADER]: generateRandomGuid(),
  };
}

function generateTolkienHeaders(cookies) {
  const requestHeadersTolkien = {};
  for (let key in cookies) {
    if (key.startsWith(allowedKeysForTolkien)) {
      requestHeadersTolkien[key] = cookies[key];
    }
  }
  return requestHeadersTolkien;
}

function getCookies(){
  const pairs = document.cookie.split(';');
  const cookies = {};
  for (let i=0; i<pairs.length; i++){
    const pair = pairs[i].split('=');
    cookies[String(pair[0]).trim()] = unescape(pair[1]);
  }
  return cookies;
}

function createApiClient(apiManager, networkConfig = {}) {
  function makeRequest(method, url, paramsArgument, configArgument) {
    let config, params, promise;

    if (configArgument) {
      config = configArgument;
      params = paramsArgument;

      promise = apiManager.api[method](
        url,
        params,
        {
          ...config,
          ...networkConfig,
        }
      );
    } else {
      config = paramsArgument;
      promise = apiManager.api[method](
        url,
        {
          ...config,
          ...networkConfig,
        }
      );
    }

    return promise;
  }

  return {
    get(url, config) {
      return makeRequest('get', url, config);
    },

    post(url, params, config) {
      return makeRequest('post', url, params, config);
    },

    put(url, params, config) {
      return makeRequest('put', url, params, config);
    },

    delete(url, config) {
      return makeRequest('delete', url, config);
    },

    head(url, config) {
      return makeRequest('head', url, config);
    },

    options(url, config) {
      return makeRequest('options', url, config);
    },
  };
}

export {
  createApiClient,
  generateCustomHeadersForTracking,
  generateTolkienHeaders,
  getCookies,
};



// WEBPACK FOOTER //
// ./src/common/network/apiUtils.js